import React from 'react';
import styles from './App.module.scss';
import { Provider } from 'react-redux';
import store from './store';
import DefaultScene from './components/home/DefaultScene';
import RecipeCardDetailsScene from './components/recipe/RecipeCardDetailsScene';
import CookbookScene from './components/cookbook/CookbookScene';
import CreateAccount from './components/authentication/CreateAccount';
import Scene from './components/scene/Scene';
import { Route, Routes } from 'react-router-dom';
import Login from './components/authentication/Login';
import ResetPassword from './components/authentication/ResetPassword';
import Account from './components/user/Account';
import PuzzleDetailsScene from 'components/puzzles/PuzzleDetailsScene';

const App: React.FunctionComponent = () => {
  return (
    <Provider store={store}>
      <div className={styles.App} data-testid="app-screen">
        <Routes>
        <Route
            path="/puzzles"
            element={
              <Scene sceneName="PuzzleDetailsScene">
                <PuzzleDetailsScene />
              </Scene>
            }
          />
          <Route
            path="/recipe/:id"
            element={
              <Scene sceneName="RecipeCardDetailsScene">
                <RecipeCardDetailsScene />
              </Scene>
            }
          />
          <Route
            path="/account"
            element={
              <Scene sceneName="Account" authRequired={true}>
                <Account />
              </Scene>
            }
          />
          <Route
            path="/cookbook/:id"
            element={
              <Scene sceneName="CookbookScene" authRequired={true}>
                <CookbookScene />
              </Scene>
            }
          />

          <Route
            path="/cookbook"
            element={
              <Scene sceneName="CookbookScene" authRequired={true}>
                <CookbookScene />
              </Scene>
            }
          />

          <Route
            path="/create"
            element={
              <Scene sceneName="CreateAccount">
                <CreateAccount />
              </Scene>
            }
          />
          <Route
            path="/reset"
            element={
              <Scene sceneName="ResetPassword">
                <ResetPassword />
              </Scene>
            }
          />
          <Route
            path="/login"
            element={
              <Scene sceneName="Login">
                <Login />
              </Scene>
            }
          />
          <Route
            path="/"
            element={
              <Scene sceneName="DefaultScene">
                <DefaultScene />
              </Scene>
            }
          />
        </Routes>
      </div>
    </Provider>
  );
};

export default App;
